import { ReactNode } from 'react';
import styled from 'styled-components';

import InProgressIcon from '#/assets/InProgressIcon';

const LoadingOverlayContainer = styled.div.attrs({
  children: <InProgressIcon size={22} />,
})`
  display: grid;
  place-items: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

interface LoadableProps {
  readonly isLoading: boolean;
  readonly children: ReactNode;
  readonly className?: string;
}

export function Loadable(props: LoadableProps) {
  const opacity = props.isLoading ? '0.2' : '1';
  return (
    <>
      <Container
        className={props.className}
        css={`
          opacity: ${opacity};
        `}
      >
        {props.children}
      </Container>
      {props.isLoading && <LoadingOverlayContainer />}
    </>
  );
}

const Container = styled.div`
  min-width: 100%;
  min-height: 100%;
`;
